function fixProductSlideDimensions(height = false) {
    $('.js-slider-product .slider_slide').each(function() {
        let el = $(this);
        let h = height ? height : el.closest('.slick-track').height();
        el.height(h);
    });
}

function checkProductFormValidity(productForm) {
    const $form = $(productForm)[0];
    const $$form = $($form);

    // Ensure the form validates first
    if (!$form || !$form.checkValidity()) {
        return false;
    }

    // // Also ensure all GPO required fields have a value
    // for (const $gpoElement of $form.querySelectorAll('.gpo-element:has(.required)')) {
    //     const $gpoInput = $gpoElement.querySelector('[name]');
    //     if ($gpoInput) {
    //         const gpoInputValueSelector = `[name="${$gpoInput.getAttribute('name')}"]`;
    //         const value = ($gpoInput.getAttribute('type') === 'radio')
    //             ? $$form.find(`${gpoInputValueSelector}:checked`).val()
    //             : $$form.find(gpoInputValueSelector).val();
    //         if (!value || (typeof value === 'string' && value.trim().length == 0)) {
    //             return false;
    //         }
    //     }
    // }

    return true;
}

function initCheckVariantAvailability() {
    var $colors = jQuery('.colors-row');
    var $sizes = jQuery('.option-size');
    var controlClass = 'no-available-colors';

    $('.radio--color').click(function(){

        setTimeout(() => {
            checkSelectedSize();
        }, 10);
    });

    if ($sizes.length < 1) {
        $sizes = $('.shopify-product-form select.js-tryon-size');
    }

    function hasAvailableColors() {
        var hasAvailable = false;

        $('.colors-row').find('.radio--color').each(function() {
            if (!jQuery(this).hasClass('disabled')) {
                hasAvailable = true;
            }
        });

        return hasAvailable;
    }

    function checkSelectedSize() {
        // Check if length property exists and ensure it's selected
        var $length_selector = $('.option-length[required]');
        if ($length_selector.length > 0 && $length_selector.val().trim().length == 0) {
            disableAddToCartBtn('* Please select a size and length.');
            return;
        }

        // Check for at least 1 size to be selected
        var $selected_size = $('.option-size').val();
        if ($selected_size === "" || $selected_size === "undefined") {
            disableAddToCartBtn('* Please select a size.');
        } else {
            enableAddToCartBtn();
        }

        // This will be used to notify other parts of the site that something changed (like the Showroom)
        kbEmitEvent('pdp_variant_selected', {
            size: $selected_size,
            color: $('.radio--color input:checked').val(),
            variant: $('#product-select').val(),
        });
    }

    function toggleColors() {
        if (!hasAvailableColors()) {
            $colors.addClass(controlClass);
            disableAddToCartBtn('* No colors available for this selection.', true);
        } else {
            $colors.removeClass(controlClass);
        }
    }

    $sizes.on('change', function() {
        toggleColors();
        checkSelectedSize();
        window.dispatchEvent(new Event('resize'));
    });

    setTimeout(checkSelectedSize, 1);
}

function initCustomAddToCart() {
    // $('.js-custom-add-to-cart').on('click', function (e) {
    //     e.preventDefault();

    //     var $form = $(this).closest('form');
    //     var handle = $(this).data('handle');

    //     if ( $form.find('#tag_property_size-list-1').length > 0 && $form.find('#tag_property_size-list-1').val() == '' ) {
    //         disableAddToCartBtn('* Please select a size.');
    //         return false;
    //     }

    //     var $expedited = $form.find('#tag_property_expedited-processing');
    //     if ($expedited.length && $expedited.find('option:selected').data('charge') !== undefined) {
    //         var item_id = $expedited.find('option:selected').data('charge');
    //         $form.append('<input type="hidden" name="properties[_charge_item]" value="' + item_id + '">');

    //         $.post('/cart/add.js', {
    //                 quantity: 1,
    //                 id: item_id,
    //                 properties: {
    //                 '_hidden_product': '1'
    //             }
    //         }, function () {
    //             setTimeout( () => {
    //                 submitForm($form, handle);
    //             }, 1000); // This delay is because shopify has some issues when adding ajax + form very soon. 
    //         }, 'json');

    //     } else {
    //         submitForm($form, handle);
    //     }

    // });

    // function submitForm($form, handle) {
    //     $.get('/products/' + handle + '.json', function (response) {
    //     var id = $form.find('[name=id]').val();
    //     var variant = response.product.variants.filter(function (v) {
    //         return v.id == parseInt(id);
    //     })[0];

    //     fbq('track', 'AddToCart', {
    //         content_name: response.product.title,
    //         content_ids: [response.product.id],
    //         content_type: 'product',
    //         value: variant.price,
    //         currency: 'USD'
    //     });

    //     $form.submit();
    //     }, 'json');
    // }
}

// v8.9.15.10: Use a document-level delegated handler bound on DOM ready.
// initCustomRemoveItemFromCart() is only invoked from the
// custom:product-edition-selected event listener — that event never fires
// on the /cart page, so the previous direct .on('click') binding never
// attached. The default href navigation took over, causing "line parameter
// is invalid" on rapid consecutive clicks.
var kbRemovalInProgress = false;
$(function() {
    $(document).off('click.kbRemove').on('click.kbRemove', '.js-custom-remove-from-cart', function(e) {
        // Cart-drawer remove links also have this class but are handled separately
        // (they have .ajax-cart-remove and their own POST flow). Skip those.
        if ($(this).hasClass('ajax-cart-remove')) return;

        e.preventDefault();
        if (kbRemovalInProgress) return;

        var $link = $(this);
        var $row = $link.closest('tr');
        var lineKey = $row.attr('data-line-key');

        // Fallback to legacy href nav if data-line-key is missing
        if (!lineKey) {
            window.location.href = $link.attr('href');
            return;
        }

        kbRemovalInProgress = true;
        $link.css({ opacity: 0.5, 'pointer-events': 'none' });

        $.get('/cart.js', function(cart) {
            var chargeUpdate = null;

            if (cart && cart.items && cart.items.length) {
                var itemToRemove = null;
                for (var i = 0; i < cart.items.length; i++) {
                    if (cart.items[i].key === lineKey) {
                        itemToRemove = cart.items[i];
                        break;
                    }
                }
                if (itemToRemove && itemToRemove.properties && itemToRemove.properties._charge_item) {
                    for (var j = 0; j < cart.items.length; j++) {
                        if (cart.items[j].id == itemToRemove.properties._charge_item) {
                            chargeUpdate = {
                                id: cart.items[j].id,
                                quantity: cart.items[j].quantity - itemToRemove.quantity
                            };
                            break;
                        }
                    }
                }
            }

            var removeLine = function() {
                $.post({
                    url: '/cart/change.js',
                    data: { id: lineKey, quantity: 0 },
                    dataType: 'json'
                }).always(function() {
                    window.location.reload();
                });
            };

            if (chargeUpdate) {
                $.post({
                    url: '/cart/change.js',
                    data: chargeUpdate,
                    dataType: 'json'
                }).always(removeLine);
            } else {
                removeLine();
            }
        }, 'json').fail(function() {
            kbRemovalInProgress = false;
            $link.css({ opacity: '', 'pointer-events': '' });
        });
    });
});

// Keep this function name + body for backward compatibility with the
// custom:product-edition-selected invocation chain. It's now a no-op
// because the real binding is the delegated handler above.
function initCustomRemoveItemFromCart() {
    // intentionally empty — see v8.9.15.10 delegated handler above
    return;
    // dead code retained only to preserve scoping during diff
    var removalInProgress = false;
    $('.unused-selector-v8-9-15-10').on('click', function(e) {
        e.preventDefault();
        if (removalInProgress) return;

        var $link = $(this);
        var $row = $link.closest('tr');
        var lineKey = $row.attr('data-line-key');

        // Fallback to legacy href nav if data-line-key is missing for any reason
        if (!lineKey) {
            window.location.href = $link.attr('href');
            return;
        }

        removalInProgress = true;
        $link.css({ opacity: 0.5, 'pointer-events': 'none' });

        $.get('/cart.js', function(cart) {
            var chargeUpdate = null;

            if (cart && cart.items && cart.items.length) {
                var itemToRemove = null;
                for (var i = 0; i < cart.items.length; i++) {
                    if (cart.items[i].key === lineKey) {
                        itemToRemove = cart.items[i];
                        break;
                    }
                }
                if (itemToRemove && itemToRemove.properties && itemToRemove.properties._charge_item) {
                    for (var j = 0; j < cart.items.length; j++) {
                        if (cart.items[j].id == itemToRemove.properties._charge_item) {
                            chargeUpdate = {
                                id: cart.items[j].id,
                                quantity: cart.items[j].quantity - itemToRemove.quantity
                            };
                            break;
                        }
                    }
                }
            }

            var removeLine = function() {
                $.post({
                    url: '/cart/change.js',
                    data: { id: lineKey, quantity: 0 },
                    dataType: 'json'
                }).always(function() {
                    window.location.reload();
                });
            };

            if (chargeUpdate) {
                $.post({
                    url: '/cart/change.js',
                    data: chargeUpdate,
                    dataType: 'json'
                }).always(removeLine);
            } else {
                removeLine();
            }
        }, 'json').fail(function() {
            // Network error — re-enable the link so user can retry
            removalInProgress = false;
            $link.css({ opacity: '', 'pointer-events': '' });
        });
    });
}

function initCustomUpdateCartItemQuantity() {
    jQuery('.field--quantity').on('change', function() {
        var currentField = jQuery(this);
        if (currentField.data('charge-key') !== undefined) {
            var chargeQtyField = jQuery('input[data-id="' + currentField.data('charge-key') + '"]');
            if (currentField.val() < currentField.data('current')) {
                chargeQtyField.val(parseInt(chargeQtyField.val()) - 1);
            } else {
                chargeQtyField.val(parseInt(chargeQtyField.val()) + 1);
            }

            currentField.data('current', currentField.val());
        }
    });
}


function initCartCheckOnLoad() {
    if (!$('body').hasClass('template-cart')) {
        return;
    }

    $.get('/cart.js', function (cart) {
        var hiddenProductId = null;
        var count = 0;
        var hiddenProductCount = 0;

        $.each(cart.items, function (key, item) {
            if ( item.properties._hidden_product != null) {
                hiddenProductId = item.key;
                hiddenProductCount = item.quantity;
            }

            if ( item.properties._charge_item != null ) {
                count += item.quantity;
            }
        });

        // We need to make the hidden product match. 
        if ( count != hiddenProductCount && hiddenProductId ) {
            $.post('/cart/change.js', {
                quantity: count,
                id: hiddenProductId
            }, function () {
                window.location.reload();
            });
        }

    }, 'json');
}

/**
 * Try on dresses customizations.
 */
function initTryOnDressesBehaviors() {
    var $tryOnSize = $('.js-tryon-size');
    var $tryOnColors = $('.js-tryon-colors');
    var $thumbs = $('.js-slider-thumbs');
    var $productSlider = $('.js-slider-product');
    var selectedColor = '';

    // We skip these bindings if the tryon-size selector is not found.
    if ($tryOnSize.length < 1) return;

    // This is the initial product load.
    getTryOnProductFromSize();
    $tryOnSize.on('change', getTryOnProductFromSize);

    // Let's find the first try-on variant which is available
    const tryOnSizesOptions = [];
    $tryOnSize.find('option').each(
        (i, $option) => tryOnSizesOptions.push({
            size: $option.getAttribute('value'),
            handle: $option.getAttribute('data-product-handle'),
        })
    );
    Promise.all(
        tryOnSizesOptions.map(option => fetch(`/products/${option.handle}.js`).then(response => response.json()))
    ).then(tryOnSizesResult => {
        function getFirstAvailableProductAndVariant() {
            for (const product of tryOnSizesResult) {
                for (const variant of product.variants) {
                    if (variant.available) {
                        return { product, variant };
                    }
                }
            }
            return null;
        }

        const firstAvailable = getFirstAvailableProductAndVariant();
        if (firstAvailable) {
            const selectValue = tryOnSizesOptions.filter(
                option => option.handle == firstAvailable.product.handle
            ).shift();
            $tryOnSize.val(selectValue.size);
            $tryOnSize.trigger('change');
        }
    });

    /**
     * I don't like to have this here, but we need to hook some behaviors
     * to make sure no more items than available are added. and unfortunatelly
     * that cannot be done using regula product adds. We need to rely on the Ajax
     * API.
     */
    $('.shopify-product-form').on('submit', function(event) {
        event.preventDefault();

        let properties = {};
        var $expedited2 = $(this).find('#tag_property_expedited-processing-2');
        if ($expedited2.length > 0 && $expedited2.find('option:selected')) {
            let value = $expedited2.length > 0 ? $expedited2[0].value : '';
            properties = {
                'Estimated Delivery': value
            }
        }

        var data = {
            id: $(this).find('[name=id]').val(),
            quantity: $(this).find('[name=quantity]').val(),
            properties: properties
        };

        $.ajax({
            url: '/cart/add.js',
            method: 'POST',
            dataType: 'json',
            data: data,
            success: function(response) {
                // Open the cart drawer (matches MTO add-to-cart behavior).
                // The drawer-open helpers live in another closure and are exposed on window.
                if (typeof window.kbTriggerCartDrawer === 'function') {
                    window.kbTriggerCartDrawer(true);
                    if (typeof window.kbCartInit === 'function') {
                        window.kbCartInit();
                    }
                } else {
                    // Fallback: navigate to cart page if drawer helpers aren't available
                    window.location.href = '/cart';
                }
            },
            error: function(jqXHR, textStatus, errorThrown) {
                if (jqXHR.responseJSON && jqXHR.responseJSON.status == 422) {
                    alert(jqXHR.responseJSON.description);
                } else {
                    console.error(jqXHR);
                }
            }
        });
    });


    /**
     * This pulls the product from the selected size and loads everything
     * into the view.
     */
    function getTryOnProductFromSize() {
        var handle = $tryOnSize.find('option:selected').data('product-handle');
        $('.option-size').val($tryOnSize.val());

        $('.js-custom-add-to-cart').attr('data-handle', handle); // used by the form submission button.
        $tryOnColors.empty();

        $.get('/products/' + handle + '.js', function(product) {

            // We need to create the productImages array when the product changes.
            getImagesFromProduct(product);

            var variants = product.variants.filter(function(variant) {
                return variant.available;
            });

            variants.forEach(function(variant, key) {
                var color_handle = variant.option1.trim().toLowerCase().replace(' ', '-').replace('/', '-');
                var colorF = window.productColors.filter(function(c) {
                    return (c[color_handle] != null);
                });
                if (typeof colorF[0] != "undefined")
                    var color = colorF[0][color_handle];

                // here we start building the radio button for each variant.
                $('<li>')
                    .append(
                        $('<div>', { 'class': 'radio radio--color' })
                            .append(
                                $('<input>', {
                                    type: 'radio',
                                    name: 'color-' + product.id,
                                    id: 'field-color-' + key,
                                    value: color_handle,
                                    'data-index': key,
                                    'data-variant-id': variant.id,
                                })
                            ).append(
                            $('<label>', {
                                'data-handle': color_handle,
                                'title': variant.option1,
                                'for': 'field-color-' + key,
                                'style': 'background: ' + color + ';',
                            }).append('<small style="background: ' + color + ';"></small>')
                                .append('<strong></strong>')
                                .append('<span class="radio__tooltip">' + variant.option1 + '</span>')
                        )
                    ).appendTo($tryOnColors);
                $(document).trigger('colors-row-updated');
            });

            selectInitialVariant();

            if (variants.length === 0) {
                $('.colors-row .has-available').hide();
                $('.colors-row .no-colors').show();
                disableAddToCartBtn('* No colors available for this selection.');
                $(document).trigger('colors-row-updated-no-colors');
                return;
            } else {
                $('.no-available-colors').removeClass('no-available-colors');
                $('.no-available-sizes').removeClass('no-available-sizes');
                $('.colors-row .has-available').show();
                $('.colors-row .no-colors').hide();
                enableAddToCartBtn(true);
            }
        }, 'json');
    }

    /**
     * Select the matching color from a prior selection, or the first available color.
     */
    function selectInitialVariant() {
        var existing = $tryOnColors.find('.radio label').filter(function() {
            return $(this).data('handle') == selectedColor;
        });

        if (existing.length > 0) {
            existing.click();
        } else {
            $tryOnColors.find('.radio label').eq(0).click();
        }
    }


    /**
     * Defines properties for a given link, like resizing, or cropping.
     * @param {string} imageUrl image string.
     * @param {string} params params to replace in the string.
     */
    function defineImagePoperties(imageUrl, params) {
        return (imageUrl == null) ?
            null :
            imageUrl.replace(/\.(jpe?g|png|gif)\?v=/g, `_${params}.$1?v=`);
    }

    // This method pulls the images and prepares them to be loaded in
    // the gallery, according to the existing bundled code.
    function getImagesFromProduct(product) {
        var images = product.variants.map(function(v) {
            return v.featured_image;
        });

        var imagesArray = [];

        images.forEach(function(image, key) {
            if (image != null) {
                if (image.alt == null) image.alt = '';
                imagesArray.push({
                    index: key,
                    id: image.id,
                    colorHandle: image.alt.split('|')[0].toLowerCase().trim().replace(' ', '-') || image.alt,
                    color: image.alt.split('|')[0] || image.alt,
                    alt: image.alt,
                    feature: defineImagePoperties(image.src, '924x'), // resized to 924x
                    thumb: defineImagePoperties(image.src, '204x'), // resized to 204x
                    link: image.src // Original
                });
            }
        });

        // And here somehow I need to load the global images.
        product.images.forEach(function(image) {
            // We basically check if the image exists for a variant.
            var exists = imagesArray.filter(function(img) {
                return img.link.indexOf(image) > -1;
            }).length > 0;

            if (exists) return;

            imagesArray.push({
                index: imagesArray.length, // just to continue at the end.
                id: 0,
                colorHandle: '',
                color: '',
                alt: '',
                feature: 'https:' + defineImagePoperties(image, '924x'), // resized to 924x
                thumb: 'https:' + defineImagePoperties(image, '204x'), // resized to 204x
                link: 'https:' + image // Original
            });
        });

        window.productImages.images = imagesArray;
    }

    $('.js-tryon-colors').on('change', 'input[type=radio]', function(event) {
        var $input = $('.js-tryon-colors input:checked');
        var handle = $input.val();

        $('.js-color-name').text($input.next('label').attr('title'));
        $("input[name=id]").val($input.data('variant-id'));

        selectedColor = handle;
        $productSlider.attr('data-color', handle);
        $thumbs.attr('data-color', handle);
        window.createProductSlides($thumbs, handle);
        window.createProductSlides($productSlider, handle);
    });
}

function submitOOSNotificationForm() {

    let oosForm = $('.out-of-stock-form');
    let oosMessage = $('.out-of-stock-message');
    let oosError = $('.out-of-stock-error');
    let productHandle = $('select[name="size"]').find('option:selected').attr('data-product-handle');
    let email = $('input[name="oos-email"]');

    $.ajax({
        url: `/products/${productHandle}.js`,
        success: function(productResponse) {
            const product = JSON.parse(productResponse);
            const productId = product.id;

            if (email.length < 1 || typeof productId == "undefined" || productId == "undefined") {
                productId = $('#product-select').closest('form').attr('id').replace('product_form_', '');
                if (typeof productId == "undefined" || productId == "undefined") return;
            }
        
            email = email.val();
            if (typeof email == "undefined" || !isValidEmail(email)) return;
        
            const formData = new FormData();
            formData.append('product_id', productId);
            formData.append('email', email);
        
            $.ajax({
                url: 'http://kb-stock-alerts.riessgroup.com/api/notify',
                contentType: false,
                processData: false,
                type: 'POST',
                dataType: 'json',
                data: formData,
                success: function(response) {
                    oosMessage.show();
                    oosError.hide();
                    oosForm.hide();
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    oosError.show().html('<p>' + jqXHR.responseJSON.message + '</p>');
                }
            });
        }
    })
}

function submitOOSKlaviyoSubscribe(listId) {
    let checkbox = $('input[name="subscribe-to-klaviyo"]');

    if (!checkbox.prop('checked')) return;

    let oosForm = $('.out-of-stock-form');

    let email = $('input[name="oos-email"]').val();
    let fname = $('input[name="oos-fname"]').val();

    if (typeof email == "undefined" || !isValidEmail(email)) return;
    if (typeof fname == "undefined" || fname === '') fname = oosForm.data('customer-first-name');

    makeKlaviyoApiRequest('client/profiles', makeKlaviyoRequestData('profile', {}, {
        email: email,
        first_name: fname,
    }));
}

function klaviyoSubscribeUserToOOSList(email) {
    let listId = null;
    let oosForm = $('.out-of-stock-form');
    if (oosForm.length > 0) {
        listId = oosForm.data('klaviyo-list-id');
    }
    if (listId == null) return;

    let data = {
        g: listId,
        email: email,
    };

    let fname = $('input[name="oos-fname"]').val();
    let lname = $('input[name="oos-lname"]').val();

    if (typeof fname == "undefined" || fname === '') fname = oosForm.data('customer-first-name');
    if (typeof lname == "undefined" || lname === '') lname = oosForm.data('customer-last-name');

    if (typeof fname != "undefined" && fname !== '') data.first_name = fname;
    if (typeof lname != "undefined" && lname !== '') data.last_name = lname;

    $.ajax({
        url: '//manage.kmail-lists.com/ajax/subscriptions/subscribe',
        type: 'POST',
        dataType: 'json',
        data: data,
        success: function(response) {
        },
        error: function(jqXHR, textStatus, errorThrown) {
            console.error(jqXHR)
        }
    });
}

function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}

function disableAddToCartBtn(message) {
    showOOSForm();
    $('.cart__required_msg').slideUp().remove();
    $('.js-custom-add-to-cart').attr('disabled', 'disabled');
    $('<div class="cart__required_msg">' + message + '</div>').insertBefore('.form__actions');
    $('.cart__required_msg').hide().slideDown();
    $('.out-of-stock-form').addClass('active');
    $('.klaviyo-bis-trigger').show();

    $('.js-custom-add-to-cart').attr('title', message);

    let quantityRow = $('input[name="quantity"]').closest('.form__row');
    quantityRow.hide();

    checkGpoProperties();
}

function enableAddToCartBtn(force = false) {
    if (!force && ($('.no-available-colors').length > 0 || $('.no-available-sizes').length > 0)) return;
    hideOOSForm(force);
    $('.js-custom-add-to-cart').removeAttr('disabled');
    $('.cart__required_msg').slideUp().remove();
    $('.out-of-stock-form').removeClass('active');
    $('.klaviyo-bis-trigger').hide();

    $('.js-custom-add-to-cart').attr('title', '');

    $('.form__actions').show();

    let quantityRow = $('input[name="quantity"]').closest('.form__row');
    quantityRow.show();

    checkGpoProperties();
}

function showOOSForm(force = false) {
    if (force || $('.colors-row.no-available-colors').length > 0 || $('.option-size.no-available-sizes').length > 0) {
        let oosForm = $('.out-of-stock-form');
        if (oosForm.length < 0) return;

        let oosMessage = $('.out-of-stock-message');
        let oosError = $('.out-of-stock-error');
        let requiredMsg = $('.cart__required_msg');
        oosForm.show();
        oosError.hide();
        oosMessage.hide();
        requiredMsg.remove();
    }
}


function hideOOSForm(force = true) {
    if (force || ($('.colors-row.no-available-colors').length < 1 && $('.option-size.no-available-sizes').length < 1)) {
        let oosForm = $('.out-of-stock-form');
        if (oosForm.length < 0) return;

        let oosMessage = $('.out-of-stock-message');
        let oosError = $('.out-of-stock-error');
        oosForm.hide();
        oosError.hide();
        oosMessage.hide();
    }
}

function showOOSButton(shouldChangeAtc) {
    let button = $('.js-custom-add-to-cart');
    let optionSelect = $('.option-size');
    button.html(button.attr('data-outofstock-message'));
    if (shouldChangeAtc) {
        button.attr('disabled', 'disabled');
    }
    optionSelect.addClass('no-available-sizes');
    $('.klaviyo-bis-trigger').show();
    checkGpoProperties();
}

function hideOOSButton(shouldChangeAtc) {
    let button = $('.js-custom-add-to-cart');
    let optionSelect = $('.option-size');
    button.html(button.attr('data-addtocart-message'));
    if (shouldChangeAtc) {
        button.removeAttr('disabled');
    }
    optionSelect.removeClass('no-available-sizes');
    $('.klaviyo-bis-trigger').hide();
    checkGpoProperties();
}

function checkIfSizeInStock(selectedHandle, selectElement) {
    let productSelect = selectElement || $('#product-select');
    let button = $('.js-custom-add-to-cart');
    let optionSelect = $('.option-size');
    let selectedOption = productSelect.find('option[value="' + selectedHandle + '"]');

    // Ignores changing of hidden selects, as it might cause UI inconsistency
    if (productSelect.hasClass('hidden')) return;

    if (optionSelect.length < 1) {
        optionSelect = $('.shopify-product-form select.js-tryon-size');
    }
    if (productSelect.length < 1) {
        selectedOption = optionSelect.find('option[value="' + selectedHandle + '"]');
    }

    let disabled = true;
    selectedOption.each(function() {
        if (!$(this).prop('disabled')) disabled = false;
    });

    if (disabled) {
        showOOSButton(true);
    } else {
        hideOOSButton(true);
    }
}

document.addEventListener('custom:product-edition-selected', () => {
    initCartCheckOnLoad();
    initCheckVariantAvailability();
    // add to cart for replacing bold options
    initCustomAddToCart();
    initCustomRemoveItemFromCart();
    initCustomUpdateCartItemQuantity();
    initTryOnDressesBehaviors();
    checkGpoProperties();

    $(function() {
        let shouldHaveLoaded = false;

        const checkForSizeInput = function () {
            //showOOSForm();
            let select = $('.shopify-product-form select.js-form-select.option-size');
            if (select.length < 1) {
                select = $('.shopify-product-form select.js-tryon-size');
            }

            if (select.length > 0) {
                let selectedHandle = select.val();
                checkIfSizeInStock(selectedHandle, select);
            } else {
                // Waits for input
                if (!shouldHaveLoaded)
                    setTimeout(checkForSizeInput, 100);
            }
        };

        checkForSizeInput();

        // Prevents an infinite loop on the above function
        setTimeout(() => { shouldHaveLoaded = true }, 5000);
    });

    $(function() {
        // Prevents multiple initializations from happening
        if (this.init_products_custom) return;
        this.init_products_custom = true;

        // we use this variable to hold an in stock variant id, if we find any. 
        let in_stock_product = null; 
        let in_stock_variant = null; 
    
        // On load, we fetch the in stock version of the product.
        if ($('.js-custom-add-to-cart').data('handle')) {
            $.get('/products/in-stock-' + $('.js-custom-add-to-cart').data('handle') + '.js', function(product) {
                in_stock_product = product; 
            }, 'json'); 
        }

        // this function checks if there's an in stock version of this variant, 
        // and if there's, then it chooses the variant. 
        function checkInStockVariant() {
            if ( !in_stock_product ) return; 

            const handle = $('.list-radios--colors input:checked').val();
            const size = $('select[id^=tag_property_size-list].option-size').val();
            
            const variant = in_stock_product.variants.filter(variant => {
                return variant.option1.trim() == size.trim()
                    && variant.option2.toLowerCase().replace(' ', '-').trim() == handle.trim()
            })[0] || null;  

            in_stock_variant = variant && variant.inventory_quantity > 0
                ? { id: variant.id, quantity: variant.inventory_quantity }
                : null; 

            toggleInStockExpeditedShippingOption()
            updateVariantIdInputField();
        }


        function toggleInStockExpeditedShippingOption()
        {
            const quantity = $('.shopify-product-form input[name=quantity]').val();
            const select = $('#tag_property_expedited-processing'); 
            const standard = select.find('option.standard');
            const instock = select.find('option.instock');
            const enable = in_stock_variant != null
                && in_stock_variant.quantity >= quantity; 

            standard.toggleClass('hidden', enable);

            // Hides all other options
            select.find('option:not(.instock)').each((i, o) => {
                $(o).toggleClass('hidden', enable);
                $(o).prop('hidden', enable);
                $(o).prop('disabled', enable);
            });
            
            // Makes In-Stock option visible
            instock.toggleClass('hidden', !enable);
            instock.prop('hidden', !enable);
            instock.prop('disabled', !enable);

            const currentValue = select.val(); 
            const exists = select.find('option:not(.hidden)').filter((i, option) => option.value == currentValue).length > 0;

            if (!exists) {
                const selected = select.find('option:not(.hidden)')[0];
                select.find('option').prop('selected', false);

                select.val(selected.value);
                $(selected).prop('selected', true);
            }
        }

        /**
         * This method checks if there's an in stock variant to add, and if the quantity 
         * is allowed. Otherwise it defaults to the standard variant. 
         */
        function updateVariantIdInputField()
        {
            const quantity = $('.shopify-product-form input[name=quantity]').val();
            const $select = $('#product-select');

            if ( in_stock_variant && in_stock_variant.quantity >= quantity ) {
                $select.prop('disabled', true);
                if ($('input.in-stock-variant').length > 0) {
                    $('input.in-stock-variant').val(in_stock_variant.id); 
                } else {
                    $select.before(
                        $('<input type="hidden" name="id" class="in-stock-variant" value="'+ in_stock_variant.id +'">') 
                    );
                }
            } else {
                $select.prop('disabled', false);
                $('input.in-stock-variant').remove();
            }
        }


        $(document).on('change', '.js-colors-change input', function() {
            let productSelect = $('#product-select');
            let button = $('.js-custom-add-to-cart');

            let selectedOption = productSelect.find('option:selected');
            let selectedOptionDisabled = selectedOption.prop('disabled');

            if (selectedOptionDisabled) {
                showOOSButton(true);
                button.html(button.attr('data-outofstock-message'));
            } else {
                hideOOSButton(true);
                button.html(button.attr('data-addtocart-message'));
            }

            checkInStockVariant(); 
        });

        $('select[id^=tag_property_size-list].option-size').on('change', function() {
            checkInStockVariant();
        });

        $('input#quantity').on('change', function() {
            checkInStockVariant();
        });

        $(window).on('load resize', function() {
            fixProductSlideDimensions();
        });

        $(document).on('colors-row-updated-no-colors', function() {
            $('.colors-row').addClass('no-available-colors');
            disableAddToCartBtn('* No colors currently available.');
            showOOSForm();
        });

        $(document).on('colors-row-updated', function() {
            $('.colors-row').removeClass('no-available-colors');
        });

        $(document).on('click', '.js-slider-thumbs .slider__slide-image > a', function(e) {
            e.preventDefault();
        });

        $(document).on('click', '.oos-submit', function() {
            submitOOSNotificationForm();
            submitOOSKlaviyoSubscribe();
        });

        $(document).on('change', '.shopify-product-form select.js-form-select.option-size', function() {
            let selectedHandle = $(this).val();
            checkIfSizeInStock(selectedHandle);
            initCheckVariantAvailability();
            //showOOSForm();
        });

        $(document).on('change', '.shopify-product-form select.option-length[required]', function() {
            initCheckVariantAvailability();
        });

        var cart_items = [];
        var cart_drawer_menu_item = $('.nav-access ul li a[data-toggle-cart-drawer]');

        function cart_init() {
            $('.cart-drawer-back').addClass('loading');
            jQuery.getJSON('/cart.js', function(cart) {
                $('.cart-drawer-back').removeClass('loading');

                var has_expedited_processing = false;
                var expedited_processing_item = null;

                if (cart.item_count > 0) {
                    cart_items = cart.items;
                    var items = cart.items;
                    var total_price = '$' + (cart.total_price / 100).toFixed(2);
                    var sub_total_price = '$' + (cart.items_subtotal_price / 100).toFixed(2);

                    $('.cart-items').empty();
                    $('.cart-line-items').empty();

                    for (var i = 0; i < items.length; i++) {
                        var id = items[i].id
                        var title = items[i].product_title;
                        var qty = items[i].quantity;
                        var img = items[i].image;
                        var price = '$' + (items[i].final_line_price / 100).toFixed(2);
                        var option = items[i].variant_title;
                        var size = 0;
                        if(items[i].properties) size = items[i].properties['Dress Size'];
                        if (!option) option = '';

                        // Is this product "Expedited processing", if so, saves on the cart for later consideration when summing all counts
                        var is_expedited_processing = title && (title.toLowerCase().includes('expedited processing') || title.toLowerCase().includes('rush production'));
                        if (is_expedited_processing)
                            has_expedited_processing = true;

                        var cart_img = img
                            ? `<div class="cart-image">
                                <div class="image">
                                    <img src="${img}">
                                </div>
                            </div>`
                            : '';

                        var cart_option = (!is_expedited_processing && option)
                            ? `<div class="cart-option">
                                Color: ` + option + `
                                </div>`
                            : '';
                        
                        // All Properties
                        var cart_properties = '';
                        if ( items[i].properties ) {
                            for (var property in items[i].properties) {
                                // Skip _ properties
                                if (property.startsWith('_')) continue;

                                cart_properties += `<div class="cart-option">
                                    ${property}: ${items[i].properties[property]}
                                </div>`;
                            }
                            cart_option += cart_properties;
                        }


                        var cart_size = size
                            ? `<div class="cart-option">
                                    Size: ` + size + `
                                </div>`
                            : '';

                        var cart_qty = is_expedited_processing
                            ? ''
                            : `<div class="cart-qty">
                                        <div class="form__controls">
                                            <div class="quantity-form">
                                                <input class="quantity field field--quantity cart-drawer-qty" data-line="` + (i + 1) + `" type="number" name="updates[]" value="` + qty + `" min="0" placeholder="">
                                                <i class="fa fa-angle-up qty-plus">
                                                    <?xml version="1.0" encoding="iso-8859-1"?>
                                                    <!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
                                                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                                        viewBox="0 0 330 330" style="enable-background:new 0 0 330 330;" xml:space="preserve">
                                                    <path id="XMLID_224_" d="M325.606,229.393l-150.004-150C172.79,76.58,168.974,75,164.996,75c-3.979,0-7.794,1.581-10.607,4.394
                                                        l-149.996,150c-5.858,5.858-5.858,15.355,0,21.213c5.857,5.857,15.355,5.858,21.213,0l139.39-139.393l139.397,139.393
                                                        C307.322,253.536,311.161,255,315,255c3.839,0,7.678-1.464,10.607-4.394C331.464,244.748,331.464,235.251,325.606,229.393z"/>
                                                    </svg>                                            
                                                </i>
                                                <i class="fa fa-angle-down qty-minus">
                                                    <?xml version="1.0" encoding="iso-8859-1"?>
                                                    <!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
                                                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                                        viewBox="0 0 330 330" style="enable-background:new 0 0 330 330;" xml:space="preserve">
                                                    <path id="XMLID_224_" d="M325.606,229.393l-150.004-150C172.79,76.58,168.974,75,164.996,75c-3.979,0-7.794,1.581-10.607,4.394
                                                        l-149.996,150c-5.858,5.858-5.858,15.355,0,21.213c5.857,5.857,15.355,5.858,21.213,0l139.39-139.393l139.397,139.393
                                                        C307.322,253.536,311.161,255,315,255c3.839,0,7.678-1.464,10.607-4.394C331.464,244.748,331.464,235.251,325.606,229.393z"/>
                                                    </svg>
                                                </i>
                                            </div>
                                            <!-- <input type="number" class="field field--quantity" name="updates[]" data-id="{{ line_item.key }}" id="quantity_{{- line_item.key -}}" data-current="{{- line_item.quantity -}}"{% if charge_key != blank %} data-charge-key="{{ charge_key }}"{% endif %} value="{{- line_item.quantity -}}" min="0" placeholder=""> -->
                                        </div><!-- /.form__controls -->
                                    </div>`

                        var cart_item = $(`<div class="cart-item ${is_expedited_processing ? 'expedited-processing' : ''}" data-variant-id="` + id + `">
                            ${cart_img}
                            <div class="cart-info">
                                <div class="cart-title">
                                    ` + title + `
                                </div>
                                ${cart_option}
                                ${cart_size}
                                <div class="cart-qty-remove">
                                    ${cart_qty}
                                    ${is_expedited_processing
                                        ? ''
                                        : `<div class="cart-remove">
                                            <a href="javascript:;" class="ajax-cart-remove js-custom-remove-from-cart" data-line="` + (i + 1) + `">
                                                <?xml version="1.0" encoding="utf-8"?>
                                                <!-- Svg Vector Icons : http://www.onlinewebfonts.com/icon -->
                                                <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
                                                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1000 1000" enable-background="new 0 0 1000 1000" xml:space="preserve">
                                                <metadata> Svg Vector Icons : http://www.onlinewebfonts.com/icon </metadata>
                                                <g><path d="M784.3,127.4H631.7C624.1,61.4,568,10,500,10c-68,0-124.1,51.4-131.7,117.4H215.7c-61.7,0-112,50.2-112,112v5.7c0,47.2,29.4,87.6,70.8,104V878c0,61.7,50.2,112,112,112h427.1c61.7,0,112-50.2,112-112V349.1c41.4-16.5,70.8-56.8,70.8-104v-5.7C896.2,177.6,846,127.4,784.3,127.4L784.3,127.4z M500,63.1c38.7,0,71,27.7,78.1,64.3H421.9C429.1,90.8,461.3,63.1,500,63.1L500,63.1z M772.4,878c0,32.5-26.4,58.9-58.9,58.9H286.5c-32.4,0-58.9-26.4-58.9-58.9v-521h544.8V878z M843.1,245.1c0,32.5-26.4,58.9-58.9,58.9H215.7c-32.4,0-58.9-26.4-58.9-58.9v-5.7c0-32.5,26.4-58.9,58.9-58.9h568.6c32.4,0,58.9,26.4,58.9,58.9V245.1L843.1,245.1z"/><path d="M357.7,869c14.7,0,26.5-11.9,26.5-26.5V543.5c0-14.7-11.9-26.6-26.5-26.6c-14.7,0-26.5,11.9-26.5,26.6v298.9C331.1,857.1,343,869,357.7,869L357.7,869z"/><path d="M500,869c14.7,0,26.5-11.9,26.5-26.5V543.5c0-14.7-11.9-26.6-26.5-26.6c-14.7,0-26.5,11.9-26.5,26.6v298.9C473.5,857.1,485.3,869,500,869L500,869z"/><path d="M642.3,869c14.7,0,26.5-11.9,26.5-26.5V543.5c0-14.7-11.9-26.6-26.5-26.6c-14.7,0-26.5,11.9-26.5,26.6v298.9C615.8,857.1,627.7,869,642.3,869z"/></g>
                                                </svg>
                                            </a>
                                        </div>
                                    `}
                                </div>
                            </div>
                            <div class="cart-price">
                                ` + price + `
                            </div>
                        </div>`);

                        // Fades out item when deleting
                        cart_item.find('.cart-remove a').on('click', function () {
                            $(this).closest('.cart-item').addClass('being-removed');
                        });

                        var cart_line_item = `<input type="hidden" name="updates[]" id="quantity_${id}" value="${qty}">`;

                        // Sends expedited processing as last item
                        if (is_expedited_processing) {
                            expedited_processing_item = cart_item;
                        } else {
                            $('.cart-items').append(cart_item);
                        }

                        $('.cart-line-items').append(cart_line_item);
                    }

                    if (expedited_processing_item) {
                        $('.cart-items').append(expedited_processing_item);
                    }

                    $('.subtotal-value').text(sub_total_price);

                    $('.js-custom-remove-from-cart').click(function() {
                        if ($(this).hasClass('ajax-cart-remove')) {
                            $('.cart-drawer-back').addClass('loading');
                            var line = $(this).data('line');
                            $.ajax({
                                type: "POST",
                                url: "/cart/change",
                                data: {
                                    line: line,
                                    quantity: 0
                                },
                                success: function(data) {
                                    cart_init();
                                }
                            });
                        }
                    });

                    $('.qty-plus').each(function(index) {
                        $(this).click(function(e) {
                            e.preventDefault();
                            var current = $(this).siblings("input.quantity").val();
                            var currentVal = parseInt($(this).siblings("input.quantity").val());
                            if (!isNaN(currentVal)) {
                                $(this).siblings("input.quantity").val(currentVal + 1);
                            } else {
                                $(this).siblings("input.quantity").val(1);
                            }
                            $(this).siblings("input.quantity").change();
                        });
                    });

                    // Decrement value in quantity input

                    $(".qty-minus").each(function(index) {
                        $(this).click(function(e) {
                            e.preventDefault();
                            var currentVal = parseInt($(this).siblings("input.quantity").val());
                            if (!isNaN(currentVal) && currentVal > 1) {
                                $(this).siblings("input.quantity").val(currentVal - 1);
                            } else {
                                $(this).siblings("input.quantity").val(1);
                            }
                            $(this).siblings("input.quantity").change();
                        });
                    });

                    $('.cart-drawer-qty').change(function() {
                        var qty = $(this).val();
                        var line = $(this).data('line');
                        $('.cart-drawer-back').addClass('loading');
                        $.ajax({
                            type: "POST",
                            url: "/cart/change",
                            data: {
                                line: line,
                                quantity: qty
                            },
                            success: function(data) {
                                cart_init();
                            }
                        });
                    });
                } else {
                    cart_items = [];
                }

                var total_count = has_expedited_processing
                    ? cart.item_count - 1
                    : cart.item_count;

                $('.cart-header .cart-title span').text('(' + total_count + ')');
                cart_drawer_menu_item.find('span').text(total_count);
                if (total_count > 0 && $('.cart-drawer-container').hasClass('is-empty')) {
                    $('.cart-drawer-container').removeClass('is-empty');
                }
                if (total_count == 0 && !$('.cart-drawer-container').hasClass('is-empty')) {
                    $('.cart-drawer-container').addClass('is-empty');
                }
            } );
        }

        function cart_drawer_open(handleLoadingTimeout) {
            $('body').addClass('cart-drawer-open');

            // In some rare cases, the drawer may be stuck loading, so we trigger a cart_init() that should make it refresh data
            if (handleLoadingTimeout) {
                setTimeout(() => $('.cart-drawer-back').hasClass('loading') && cart_init(), 500);
            }
        }

        function triggerCartDrawer(showLoadingSpinner) {
            // Shows cart as "loading"
            if (showLoadingSpinner) {
                $('.cart-drawer-back').addClass('loading');
            }

            // Opens cart drawer
            cart_drawer_open(showLoadingSpinner);
        }

        // Expose for the AHTO submit handler (in initTryOnDressesBehaviors), which lives
        // outside this closure and otherwise has no access to the drawer-open / cart-init logic.
        window.kbCartInit = cart_init;
        window.kbTriggerCartDrawer = triggerCartDrawer;

        if (!$('body').hasClass('template-cart')) {
            cart_init();
        }

        $('.cart-drawer-close').click(function() {
            $('body').removeClass('cart-drawer-open');
        });

        cart_drawer_menu_item.click(function(e) {
            if (!$('body').hasClass('template-cart')) {
                e.preventDefault();
                cart_drawer_open();
            }
        });
        
        /**
         * Prevents multiple clicks to ATC
         */
        var isAddingToCart = false;
        function debounceAddToCart(callback, timeout) {
            // Prevents multiple ATC events from firing
            if (isAddingToCart) {
                return;
            }
            isAddingToCart = true;

            // Callback function for marking ATC as done
            function done() {
                isAddingToCart = false;
            }

            // Sets timeout for next ATC (if not disabled)
            if (timeout !== false) {
                setTimeout(done, timeout || 1);
            }

            // Invokes our ATC
            callback(done);
        }

        /**
         * This is the Add to Cart entrypoint for normal dresses
         */
        $('.js-custom-add-to-cart').click(function(e) {
            e.preventDefault();
            var $form = $(this).closest('form');
            var handle = this.getAttribute('data-handle'); // For some reason using jQuery's built-in .data and .attr methods was returning a cached method, so we're using the native .getAttribute method instead
            var variant_id = $form.find('[name="id"]').val();
            var $expedited = $form.find('#tag_property_expedited-processing');
            var $this = $(this);

            // Checks if we already have expedited processing on cart and enables it on product if needed
            debounceAddToCart(() => {
                $.get('/cart.js', function (cart) {
                    // Checks if we have expedited on any item
                    var cart_expedited_processing = cart.items
                        .filter((item) => item.properties && item.properties._expedited_processing == '1')
                        .shift();

                    // Updates product
                    if ($expedited.length > 0 && cart_expedited_processing) {
                        $expedited.val($expedited.find('option[data-charge]').val());
                    }

                    // New expedited status
                    var new_expedited = $expedited.length > 0 && $expedited.find('option:selected').data('charge') !== undefined;

                    // Is "In Stock" variant selected?
                    const is_in_stock_variant_selected = in_stock_variant && $('#tag_property_expedited-processing').val() === $('#tag_property_expedited-processing .instock').val();
                    function handleInStockText() {
                        if (is_in_stock_variant_selected) {
                            const $property = $('#tag_property_expedited-processing');
                            const $placeholder = $('<div>').insertBefore($property);
                            
                            $(document.body).append($property);

                            return (() => {
                                $property.insertAfter($placeholder);
                                $placeholder.remove();
                            });
                        }
                        return (() => {});
                    }

                    if ($('.stock-message').length > 0) {
                        $.get('/products/' + handle + '.json', function(response) {
                            // Gets list of product variants
                            var variants = response.product.variants;

                            // This is our current variant
                            var selected_variant = variants
                                .filter(variant => variant.id == variant_id)
                                .shift();

                            // This is our current variant, on the cart
                            var selected_variant_cart = cart_items
                                .filter(item => item.id == variant_id);

                            // This will keep track of how many of that item we have on cart
                            var selected_variant_cart_qty = selected_variant_cart
                                .reduce((qty, item) => qty + item.quantity, 0);

                            // This will keep track of how many of that item we have on inventory
                            var selected_variant_available = selected_variant.inventory_quantity;

                            // Prevents adding to cart if all items are already on cart
                            if (selected_variant_cart_qty >= selected_variant_available) {
                                $('.stock-message').find('.qty').text(selected_variant_available);
                                $('.stock-message').addClass('active');
                            } else {
                                $('.stock-message').removeClass('active');
                                if ($('.option-size').val() || $('.option-size').length == 0) {
                                    if (!$this.hasClass('launch_popup') || $this.hasClass('ajax-add-to-cart')) {
                                        // Adds processing meta field
                                        if ($expedited.length) {
                                            $form.append(
                                                $('<input type="hidden" />')
                                                    .attr('name', 'properties[_processing]')
                                                    .val(new_expedited ? 'expedited' : 'normal')
                                            );
                                        }

                                        if ($expedited.length && new_expedited) {
                                            var item_id = $expedited.find('option:selected').data('charge');
                                            $form.append('<input type="hidden" name="properties[_charge_item]" value="' + item_id + '">');

                                            // Here we submit the main form (product), then on callback we submit the expedited product
                                            // This MUST be in this order, otherwise it seems like Shopify will register both products with the properties from the expedited shipping
                                            submitForm($form, handle, $this, function () {
                                                $.post('/cart/add.js', {
                                                    items: [{
                                                        quantity: 1,
                                                        id: item_id,
                                                        properties: {
                                                            '_hidden_product': '1',
                                                            '_expedited_processing': '1',
                                                        }
                                                    }]
                                                }, function() {
                                                    // Finally, we show the cart drawer to the client
                                                    cart_init();
                                                }, 'json');
                                            });
                                        } else {
                                            submitForm($form, handle, $this);
                                        }

                                        function submitForm($form, handle, _this, callback) {
                                            if (!checkProductFormValidity($form)) {
                                                return;
                                            }

                                            if (_this.hasClass('ajax-add-to-cart')) {
                                                if (!_this.hasClass('launch_popup')) {
                                                    triggerCartDrawer(true);
                                                }
                                                else {
                                                    $('.native-recommended-product-popup-section').addClass('active');
                                                }
                                            }
                                            if (_this.hasClass('ajax-add-to-cart')) {
                                                const restoreInStockText = handleInStockText();
                                                $.ajax({
                                                    type: "POST",
                                                    url: '/cart/add.js',
                                                    data: $form.serialize(),
                                                    dataType: 'json',
                                                    success: function(data) {
                                                        // If we have any callback defined, we'll call it instead of cart_init -> the callback MUST call cart_init manually then
                                                        if (callback) callback()
                                                        else cart_init();
                                                        restoreInStockText();
                                                    }
                                                });
                                            } else {
                                                $form.submit();
                                            }
                                        }
                                    }
                                } else {
                                    disableAddToCartBtn("* Please select a size");
                                }
                            }
                        }, 'json');
                    } else {
                        if ($('.option-size').val() || $('.option-size').length == 0) {
                            if (!$this.hasClass('launch_popup') || $this.hasClass('ajax-add-to-cart')) {
                                // Adds processing meta field
                                if ($expedited.length) {
                                    $form.append(
                                        $('<input type="hidden" />')
                                            .attr('name', 'properties[_processing]')
                                            .val(new_expedited ? 'expedited' : 'normal')
                                    );
                                }

                                if ($expedited.length && $expedited.find('option:selected').data('charge') !== undefined) {
                                    var item_id = $expedited.find('option:selected').data('charge');
                                    $form.append('<input type="hidden" name="properties[_charge_item]" value="' + item_id + '">');

                                    // If we have expedited shipping, we'll first submit the product form and on its callback we'll add the expedited product
                                    // This MUST be in this order, otherwise it seems like Shopify will register both products with the properties from the expedited shipping
                                    submitForm($form, handle, $this, function () {
                                        $.post('/cart/add.js', {
                                            items: [{
                                                quantity: 1,
                                                id: item_id,
                                                properties: {
                                                    '_hidden_product': '1',
                                                    '_expedited_processing': '1',
                                                }
                                            }]
                                        }, function() {
                                            // Finally, shows the cart
                                            cart_init();
                                        }, 'json');
                                    });
                                } else {
                                    submitForm($form, handle, $this);
                                }

                                function submitForm($form, handle, _this, callback) {
                                    if (!checkProductFormValidity($form)) {
                                        return;
                                    }

                                    if (_this.hasClass('ajax-add-to-cart')) {
                                        if (!_this.hasClass('launch_popup')) {
                                            triggerCartDrawer(true);
                                        }
                                        else {
                                            $('.native-recommended-product-popup-section').addClass('active');
                                        }
                                    }
                                    if (_this.hasClass('ajax-add-to-cart')) {
                                        const restoreInStockText = handleInStockText();
                                        $.ajax({
                                            type: "POST",
                                            url: '/cart/add.js',
                                            data: $form.serialize(),
                                            dataType: 'json',
                                            success: function(data) {
                                                // If we have any callback defined, we'll call it instead of cart_init -> the callback MUST call cart_init manually then
                                                if (callback) callback();
                                                else cart_init();
                                                restoreInStockText();
                                            }
                                        });
                                    } else {
                                        $form.submit();
                                    }
                                }
                            }
                        } else {
                            disableAddToCartBtn("* Please select a size");
                        }
                    }
                }, 'json');
            });
        });

        $('.recomendation_add_to_cart').click(function(e) {
            e.preventDefault();
            const $form = $(this).closest('form');

            for (const $element of $form.find('[data-name]')) {
                const old = $element.getAttribute('name');
                $element.setAttribute('name', $element.getAttribute('data-name'));
                setTimeout(() => $element.setAttribute('name', old), 1);
            }
            const form_data = $form.serialize();

            $('.native-recommended-product-popup-section').removeClass('active');
            cart_drawer_open(true);
            $.ajax({
                type: "POST",
                url: $form.attr('action'),
                data: form_data, // serializes the form's elements.
                success: function(data) {
                    cart_init();
                }
            });
        });

        $('.cart-add').click(function() {
            $('.cart-drawer-back').addClass('loading');
            var id = $(this).data('variant-id');
            $.ajax({
                type: "POST",
                url: '/cart/add',
                data: {
                    id: id,
                    quantity: 1
                },
                success: function(data) {
                    cart_init();
                }
            });
        });

        $('.cart-table-mobile-qty').change(function() {
            var qty = $(this).val();
            var line = $(this).data('line');
            document.location.href = '/cart/change?line=' + line + '&quantity=' + qty;
        });

        $('.qty-plus').each(function(index) {
            $(this).click(function(e) {
                e.preventDefault();
                var $form = $(this).closest('form');
                var data = {
                    id: $form.find('[name=id]').val(),
                    quantity: $form.find('[name=quantity]').val(),
                };
                $('.native-recommended-product-popup-section').removeClass('active');
                cart_drawer_open(true);
                $.ajax({
                    type: "POST",
                    url: $form.attr('action'),
                    data: $form.serialize(), // serializes the form's elements.
                    success: function(data) {
                        cart_init();
                    }
                });
            });
        });

        $('.cart-add').click(function() {
            $('.cart-drawer-back').addClass('loading');
            var id = $(this).data('variant-id');
            $.ajax({
                type: "POST",
                url: '/cart/add',
                data: {
                    id: id,
                    quantity: 1
                },
                success: function(data) {
                    cart_init();
                }
            });
        });

        $('.cart-table-mobile-qty').change(function() {
            var qty = $(this).val();
            var line = $(this).data('line');
            document.location.href = '/cart/change?line=' + line + '&quantity=' + qty;
        });

        $('.qty-plus').each(function(index) {
            $(this).click(function(e) {
                e.preventDefault();
                var current = $(this).siblings("input.quantity").val();
                var currentVal = parseInt($(this).siblings("input.quantity").val());
                if (!isNaN(currentVal)) {
                    $(this).siblings("input.quantity").val(currentVal + 1);
                } else {
                    $(this).siblings("input.quantity").val(1);
                }
                $(this).siblings("input.quantity").change();
            });
        });

        // Decrement value in quantity input

        $(".qty-minus").each(function(index) {
            $(this).click(function(e) {
                e.preventDefault();
                var currentVal = parseInt($(this).siblings("input.quantity").val());
                if (!isNaN(currentVal) && currentVal > 1) {
                    $(this).siblings("input.quantity").val(currentVal - 1);
                } else {
                    $(this).siblings("input.quantity").val(1);
                }
                $(this).siblings("input.quantity").change();
            });
        });

        // Wedding details popup removed — checkout button now links directly to /checkout

        function addCart(callback) {
            $form = $('.shopify-product-form');

            if (!checkProductFormValidity($form)) {
                if (callback) {
                    callback(false);
                }
                return;
            }

            let properties = {
                "Dress Size": $form.find('#tag_property_size-list-1').val(),
                "Estimated Delivery on or Before": $form.find('#tag_property_expedited-processing').val()
            };

            var data = {
                id: $form.find('[name=id]').val(),
                quantity: $form.find('[name=quantity]').val(),
                properties: properties
            };

            $.ajax({
                url: '/cart/add.js',
                method: 'POST',
                dataType: 'json',
                data: data,
                success: function(response) {
                    if (callback) {
                        callback(true);
                    }
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    if (jqXHR.responseJSON.status == 422) {
                        alert(jqXHR.responseJSON.description);
                    } else {
                        console.error(jqXHR);
                    }

                    if (callback) {
                        callback(false);
                    }
                }
            });
        }
        if ($('.native-recommended-product-popup-section').length > 0) {
            $('.js-custom-add-to-cart').addClass('launch_popup');
            var baseUrl = $('.native-recommended-product-popup-section').data('baseUrl');
            var productId = $('.native-recommended-product-popup-section').data('product-id');
            var productHandle = $('.native-recommended-product-popup-section').data('product-handle');
            var productType = $('.native-recommended-product-popup-section').data('product-type');
            var settingsProductHandle = $('.native-recommended-product-popup-section').data('settings-product-handle');
            if (productHandle == '' && productType == 'false') {
                $.ajax({
                    type: 'GET',
                    url: baseUrl + '?section_id=product-recommendations-popup&limit=' + 1 + '&product_id=' + productId,
                    success: function(data) {
                        $('#shopify-section-product-recommendations-popup').html($(data).html());
                        var recommendationProductHandle = $('.native-recommended-product-popup-section').data('recommendation-product-handle');
                        var color_url = `/products/${recommendationProductHandle}?view=product-colors`;
                        $.ajax({
                            type: 'GET',
                            url: color_url,
                            success: function(data) {
                                $(".variant-colors").html(data);
                                $('.js-custom-add-to-cart').click(() => debounceAddToCart(function() {
                                    if (($('.option-size').val() && !$(this).hasClass('ajax-add-to-cart')) || ($('.option-size').length == 0 && !$(this).hasClass('ajax-add-to-cart'))) {
                                        addCart(
                                            ok => ok && $('.native-recommended-product-popup-section').addClass('active')
                                        );
                                    }
                                }));
                                $('.recomendation_add_to_cart').click(function(e) {
                                    e.preventDefault();
                                    const $form = $(this).closest('form');
    
                                    for (const $element of $form.find('[data-name]')) {
                                        const old = $element.attr('name');
                                        $element.attr('name', $element.attr('data-name'));
                                        setTimeout(() => $element.attr('name', old), 1);
                                    }
                                    const form_data = $form.serialize();
                                    
                                    $('.native-recommended-product-popup-section').removeClass('active');
                                    $('.cart-drawer-back').addClass('loading');
                                    cart_drawer_open();
                                    $.ajax({
                                        type: "POST",
                                        url: $form.attr('action'),
                                        data: form_data, // serializes the form's elements.
                                        success: function(data) {
                                            cart_init();
                                        }
                                    });
                                });
                                $colorChange = $(".custom-js-colors-change");
                                $selectColor = $('.select-colors');

                                function selectColor() {
                                    var color_title = $colorChange.find('input:checked').data('color-title');
                                    var selected_color = $colorChange.find('input:checked').data('selected-color');
                                    $selectColor.find('label').attr('title', color_title);
                                    $selectColor.find('label').css({ "background": selected_color });
                                    $selectColor.find('small').css({ "background": selected_color });
                                    $selectColor.find('.color-title').text(color_title);
                                    $colorChange.hide();
                                }
                                selectColor();
                                $selectColor.click(function() {
                                    $colorChange.slideDown();
                                });
                                $colorChange.find('li').on('click', function(e) {
                                    e.preventDefault();
                                    $(this).find('input').prop("checked", true);
                                    var currentColor = $(this).find('input').val();
                                    $('.custom-js-color-name').text(currentColor);
                                    $('.recommendation-product-image').each(function() {
                                        if ($(this).data('color') == currentColor) {
                                            var id = $(this).data('variant-id');
                                            $(this).removeClass('hidden');
                                            $('#recommendation_product_id').val(id);
                                        } else $(this).addClass('hidden');
                                    });
                                    selectColor();
                                });
                                $('.popup-close').click(function() {
                                    $('.native-recommended-product-popup-section').removeClass('active');
                                    $colorChange.hide();
                                });
                            },
                            error: function(status) {
                                console.error("ERROR", status);
                            }
                        });
                    },
                    error: function() {
                        console.error("Recommendations content load failed");
                    }
                });
            } else {
                var color_url = '';
                if (productHandle) {
                    color_url = `/products/${productHandle}?view=product-colors`;
                } else {
                    color_url = `/products/${settingsProductHandle}?view=product-colors`;
                }
                $.ajax({
                    type: 'GET',
                    url: color_url,
                    success: function(data) {
                        $(".variant-colors").html(data);
                        $('.js-custom-add-to-cart').click(() => debounceAddToCart(function() {
                            if (($('.option-size').val() && !$(this).hasClass('ajax-add-to-cart')) || ($('.option-size').length == 0 && !$(this).hasClass('ajax-add-to-cart'))) {
                                addCart(
                                    ok => ok && $('.native-recommended-product-popup-section').addClass('active')
                                );
                            }
                        }));
                        $colorChange = $(".custom-js-colors-change");
                        $selectColor = $('.select-colors');

                        function selectColor() {
                            var color_title = $colorChange.find('input:checked').data('color-title');
                            var selected_color = $colorChange.find('input:checked').data('selected-color');
                            $selectColor.find('label').attr('title', color_title);
                            $selectColor.find('label').css({ "background": selected_color });
                            $selectColor.find('small').css({ "background": selected_color });
                            $selectColor.find('.color-title').text(color_title);
                            $colorChange.hide();
                        }
                        selectColor();
                        $selectColor.click(function() {
                            $colorChange.slideDown();
                        });
                        $colorChange.find('li').on('click', function(e) {
                            e.preventDefault();
                            $(this).find('input').prop("checked", true);
                            var currentColor = $(this).find('input').val();
                            $('.custom-js-color-name').text(currentColor);
                            $('.recommendation-product-image').each(function() {
                                if ($(this).data('color') == currentColor) {
                                    var id = $(this).data('variant-id');
                                    $(this).removeClass('hidden');
                                    $('#recommendation_product_id').val(id);
                                } else $(this).addClass('hidden');
                            });
                            selectColor();
                        });
                        $('.popup-close').click(function() {
                            $('.native-recommended-product-popup-section').removeClass('active');
                            $colorChange.hide();
                        });
                    },
                    error: function(status) {
                        console.error("ERROR", status);
                    }
                });
            }
        }

        const queryParams = new URLSearchParams(window.location.search);
        if (queryParams.get('variant')) {
            $(document).trigger('colors-row-updated');
        }

        // Whenever "go to cart" is clicked, show the cart drawer
        $('.recommendation-button.btn--go-to-cart').on('click', function (event) {
            if (event && event.preventDefault) {
                event.preventDefault();
            }

            $('.native-recommended-product-popup-section').removeClass('active');
            triggerCartDrawer(true);

            return false;
        });
    });

    var windowHeight = window.innerHeight;

    $(window).on('load resize', function(){
        var height = window.innerHeight - 237;
        if($('.cart-upsell').length > 0) {
            height -= 192;
        }
        $('.cart-drawer-container .cart-exist .cart-items').css({'height': `${height}px`});
    });
});


function checkGpoProperties() {
    if (jQuery('.gpo-label.required').length > 0) {

        let shouldDisable = false;
        let atcButton = jQuery('.js-custom-add-to-cart');

        jQuery('.gpo-label.required').each(function() {

            // Skip if hidden/not visible
            if (!jQuery(this).is(':visible')) {
                return;
            }

            const gpoInput = jQuery(this).closest('.gpo-form__group').find('input');
            gpoInput.prop('required', true);

            const gpoInputChecked = jQuery(this).closest('.gpo-form__group').find('input:checked');

            if( !gpoInputChecked.val() ) {
                shouldDisable = true;
            }
        });
        if( shouldDisable ) {
            atcButton.attr('disabled', 'disabled').text('Choose options');
        } else {
            atcButton.removeAttr('disabled');
            atcButton.text(atcButton.attr('data-addtocart-message'));
        }
        
    }
}

jQuery(document).on('change', '.gpo-container input', function() {
    checkGpoProperties();
});